import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65a2684d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=65a2684d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2684d",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumbBanner: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/BreadcrumbBanner.vue').default,BaseUiMultiselect: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/Multiselect.vue').default})
